interface Step {
    id: number;
    title: string;
    content: string;
}

/**
 * Parse a response string into an array of Step objects with title and content.
 * @param responseContent The raw response string to parse
 * @returns An array of Step objects
 */

export const parseQuestionSteps = (responseContent: any[]): Step[] => {
  if (!Array.isArray(responseContent)) return [];

  return responseContent.flatMap((item) => {
    const stepId = item.id;
    const stepsContent = item.steps_content || {};

    return Object.entries(stepsContent).map(([_, value]: [string, any]) => ({
      id: stepId,
      title: value.title || "",
      content: value.content || "",
    }));
  });
};

